export class Driver {
    name: string;
    marketingName: string;
    nc12: string;
    id: number;
    image: string;
    sortOrder: number;

    capabilities: any;

    isVisible: string;
    isVisibleNa: string;
    isVisibleSa: string;
    isVisibleCn: string;
    isVisibleRoa: string;

    isInMaintenanceMode: string;
    isInMaintenanceModeNa: string;
    isInMaintenanceModeSa: string;
    isInMaintenanceModeCn: string;
    isInMaintenanceModeRoa: string;

    viewStatus: string;
    viewStatusNa: string;
    viewStatusSa: string;
    viewStatusCn: string;
    viewStatusRoa: string;

    description: string;
    descriptionNa: string;
    descriptionSa: string;
    descriptionCn: string;
    descriptionRoa: string;

    driverFamilyIdEMEA: string;
    driverFamilyIdNA: string;
    driverFamilyIdSA: string;
    driverFamilyIdCN: string;
    driverFamilyIdROA: string;

    dimmingTypes: Array<any>;

    multiCurrents: Array<any>;

    family: any;
    housing: any;


    phaseIn: string;
    phaseInNa: string;
    phaseInSa: string;
    phaseInCn: string;
    phaseInRoa: string;

    phaseOut: string;
    phaseOutNa: string;
    phaseOutSa: string;
    phaseOutCn: string;
    phaseOutRoa: string;

    isRset1: boolean;
    isRset2: boolean;
    isRset3: boolean;
    isRset4s: boolean;
    isRset5s: boolean;
    isRsetProgrammable: boolean;
    isRsetSimpleset: boolean;
    isRsetWireless: boolean;
    isRsetDipswitch: boolean;

    datasheetUrl: string;
    datasheetUrlNa: string;
    datasheetUrlSa: string;
    datasheetUrlCn: string;
    datasheetUrlRoa: string;

    csaUrl: string;
    file3dUrl: string;
    ulUrl: string;
    inertekUrl: string;

    boxQuantity: number;
}



// WEBPACK FOOTER //
// ./src/app/_models/driver.ts